import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useLimit } from 'automation-ui-core/hooks/authHooks';
import { WEBHOOK_TRIGGER_EVENT_LIMIT_NAME, DEFAULT_WEBHOOK_TRIGGER_EVENT_LIMIT } from 'automation-ui-enrollment/constants/WebhookLimits';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookLimitCountFooter = ({
  numWebhooks,
  onClickCreateWebhook
}) => {
  const portalWebhookLimit = useLimit(WEBHOOK_TRIGGER_EVENT_LIMIT_NAME);
  const webhookLimit = Number.isFinite(portalWebhookLimit) ? portalWebhookLimit : DEFAULT_WEBHOOK_TRIGGER_EVENT_LIMIT;
  return /*#__PURE__*/_jsxs("div", {
    children: [onClickCreateWebhook && /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.events.webhookEvents.limitReached",
        options: {
          maxCount: webhookLimit
        }
      }),
      disabled: numWebhooks < webhookLimit,
      children: /*#__PURE__*/_jsxs(UIButton, {
        className: "m-y-3 m-right-3",
        use: "tertiary-light",
        size: "small",
        disabled: numWebhooks >= webhookLimit,
        onClick: onClickCreateWebhook,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "add"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.events.webhookEvents.addNewWebhook"
        })]
      })
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "automation-ui-enrollment.redesign.events.webhookEvents.webhookCount",
      options: {
        count: numWebhooks,
        maxCount: webhookLimit
      }
    })]
  });
};
export default WebhookLimitCountFooter;